import React, { useEffect, useRef, useState } from "react";
import vision from "assets/img/vision.jpeg";
import mission from "assets/img/mission.jpeg";
import values from "assets/img/values.jpg";
import mediimg1 from "assets/img/mediimg1.png";
import mediimg2 from "assets/img/mediimg2.png";
import mediimg3 from "assets/img/mediimg3.png";
import { useTranslation } from "react-i18next";
import { useLanguage } from "components/Homepage/LanguageContext";

const HoveredImage = ({ fixedImageSrc }) => {
  const { t } = useTranslation();
  return (
    <div className="md:mt-0  my-4">
      {fixedImageSrc && (
        <>
          {fixedImageSrc.text1 && (
            <p className="xl:pt-8 pt-4 text-left font-medium xl:text-4xl md:text-2xl text-xl text-white banner-font">
              {fixedImageSrc.text1}
            </p>
          )}
          {fixedImageSrc.text && (
            <h1 className="text-left xl:w-10/12 xl:pt-12 text-justify xl:text-base1 text-base text-white pt-2 banner-font">
              {fixedImageSrc.text}
            </h1>
          )}
        </>
      )}
    </div>
  );
};

export default function HoverChange() {
  const { t } = useTranslation();
  const { changeLanguage } = useLanguage();

  const sections = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
            observer.unobserve(entry.target); // Stop observing the section once it's animated
          }
        });
      },
      { threshold: 0.7 }
    );

    sections.current.forEach((section) => {
      if (section && section instanceof Element) {
        observer.observe(section);
      }
    });

    const handleScroll = debounce(() => {
      sections.current.forEach((section) => {
        if (section && section instanceof Element) {
          observer.observe(section);
        }
      });
    }, 100);

    window.addEventListener("scroll", handleScroll);

    return () => {
      observer.disconnect();
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }

  const [fixedImageSrc, setFixedImageSrc] = useState({
    text1: "",
    text: t("aboutcontent32"),
    image: vision,
  });
  const [hoveredBox, setHoveredBox] = useState(null);

  const handleBoxHover = (box) => {
    setHoveredBox(box);

    switch (box) {
      case "passionDriven":
        setFixedImageSrc({
          text: t("aboutcontent31"),
          image: vision,
        });
        break;
      case "customerCentric":
        setFixedImageSrc({
          text: t("aboutcontent32"),
          image: mission,
        });
        break;
      case "transparentApproach":
        setFixedImageSrc({
          text: t("aboutcontent33"),
          image: values,
        });
        break;
      default:
        break;
    }
  };

  return (
    <>
      <section
        ref={(el) => sections.current.push(el)}
        style={{
          width: "100%",
          backgroundSize: "cover",
        }}
        className="animate-on-scroll bg-dark"
      >
        <div className="container mx-auto relative overflow-hidden xl:px-20 px-4 xl:py-20 md:py-8 py-8">
          <div className="md:w-12/12 w-12/12 md:flex flex-none gap-2 items-center">
            <div className="lg:w-4/12 md:w-6/12 w-12/12 xl:ml-8 xl:mt-12 mt-4">
              <div
                className={`cursor-pointer round-style border passionBox bg-dark xl:w-12/12 items-center xl:p-8 pt-2 p-4 xl:pt-2 xl:h-28 ${
                  hoveredBox === "passionDriven" && "hovered"
                }`}
                onMouseEnter={() => handleBoxHover("passionDriven")}
                onMouseLeave={() => setHoveredBox(null)}
              >
                <div className="flex xl:mt-6 header-on-hover">
                  <div className="xl:mr-4 ">
                    <img
                      src={mediimg1}
                      className="xl:w-16 lg:w-16 md:w-12 w-12"
                    />
                  </div>
                  <div className="xl:w-10/12 pl-3 header-on-hover">
                    <p className="xl:text-2xl xl:mt-4 lg:mt-4 md:mt-2 mt-3 banner-font text-white font-medium text-left">
                      {t("aboutcontent28")}
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`cursor-pointer round-style-new mt-2 border passionBox bg-dark xl:w-12/12 items-center xl:p-8 pt-2 p-4 xl:pt-6 xl:h-28 ${
                  hoveredBox === "customerCentric" && "hovered"
                }`}
                onMouseEnter={() => handleBoxHover("customerCentric")}
                onMouseLeave={() => setHoveredBox(null)}
              >
                <div className="flex ">
                  <div className="xl:mr-4 ">
                    <img
                      src={mediimg2}
                      className="xl:w-16 lg:w-16 md:w-12 w-12"
                    />
                  </div>
                  <div className="xl:w-10/12 pl-3">
                    <p className="xl:text-2xl banner-font xl:mt-4 lg:mt-4 md:mt-2 mt-3 text-white text-left">
                      {t("aboutcontent29")}
                    </p>
                  </div>
                </div>
              </div>

              <div
                className={`cursor-pointer round-style border mt-2 passionBox bg-dark xl:w-12/12 items-center xl:p-8 pt-2 p-4 xl:pt-6 xl:h-28 ${
                  hoveredBox === "transparentApproach" && "hovered"
                }`}
                onMouseEnter={() => handleBoxHover("transparentApproach")}
                onMouseLeave={() => setHoveredBox(null)}
              >
                <div className="flex xl:pb-14 xl:pt-0">
                  <div className="xl:mr-4">
                    <img
                      src={mediimg3}
                      className="xl:w-16 lg:w-16 md:w-12 w-12"
                    />
                  </div>
                  <div className="xl:w-10/12 pl-3">
                    <p className="xl:text-2xl xl:mt-4 lg:mt-4 md:mt-2 mt-3 banner-font text-white text-left">
                      {t("aboutcontent30")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="md:w-7/12 w-12/12 lg:ml-12 md:ml-8">
              <HoveredImage fixedImageSrc={fixedImageSrc} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
